module.exports = __webpack_public_path__ + "static/media/Nutella macaroons.c00db08d.jpg";